import { Image } from "@chakra-ui/react";
import mark from "./images/ploy_logo_mark.svg";
import logoFull from "./images/ploy_logo.svg";
import logoWhite from "./images/logo_white.png";
import logoV2 from "./images/ploy_logo_v2.svg";

const Logo = ({ w = "100px", h = "auto" }: { w?: string; h?: string }) => {
  return <Image src={logoFull} w={w} />;
};

// Current brand logo (V2) — matches components/Logo.tsx in the main app.
// Use this for every Ploy-brand placement going forward; the V1 exports
// above remain only until their call sites migrate.
export const PloyLogoV2 = ({ w = "100px" }: { w?: string }) => {
  return <Image src={logoV2} w={w} />;
};

export const LogoWhite = ({ w = "100px" }: { w?: string }) => {
  return <Image src={logoWhite} w={w} />;
};

export const LogoMark = () => {
  return <Image src={mark} w="38px" h="38px" />;
};

export default Logo;
